//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";
import api from "../../../api";
import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';


// Round 21: one completion path for every sign-in method (password, Google).
// Stores the session, caches the access bundle, dispatches success, redirects.
const completeLogin = (data, dispatch, history) => {
  sessionStorage.setItem("authUser", JSON.stringify(data));
  // Cross-tab persistence: mirror auth into localStorage so a NEW tab can
  // inherit this login (see helpers/sessionPersist.js, which restores it).
  try { localStorage.setItem("persist:authUser", JSON.stringify(data)); } catch (e) { /* ignore */ }
  // Phase 3 (Legacy Access Parity): AuthController returns the full
  // EffectiveAccessBundle in data.access — cached under "permissions".
  const access = data?.access ?? null;
  if (access && typeof access === "object") {
    sessionStorage.setItem("permissions", JSON.stringify(access));
    try { localStorage.setItem("persist:permissions", JSON.stringify(access)); } catch (e) { /* ignore */ }
  } else if (Array.isArray(data?.permissions)) {
    sessionStorage.setItem("permissions", JSON.stringify(data.permissions));
    try { localStorage.setItem("persist:permissions", JSON.stringify(data.permissions)); } catch (e) { /* ignore */ }
  } else {
    sessionStorage.removeItem("permissions");
    try { localStorage.removeItem("persist:permissions"); } catch (e) { /* ignore */ }
  }
  dispatch(loginSuccess(data));
  const params = new URLSearchParams(window.location.search);
  const redirectTo = params.get("redirect");
  history(redirectTo ? decodeURIComponent(redirectTo) : "/dashboard");
};

const messageFromError = (error, fallback) => {
  let msg = fallback;
  if (error.response?.data) {
    const errData = error.response.data;
    if (errData.errors) {
      const messages = Object.values(errData.errors).flat();
      msg = messages.join(" ");
    } else if (typeof errData === "string") {
      msg = errData;
    } else if (errData.error) {          // Round 14: { error, retryAfterSeconds }
      msg = errData.error;
    } else if (errData.title) {
      msg = errData.title;
    }
  }
  return msg;
};

export const loginUser = (user, history) => async (dispatch) => {
  try {
    const response = await api.post("Auth/login", user);
    // Access-Management hardening (Round 1): the response carries the JWT —
    // never write it to the console.
    if (response.status === 200) {
      completeLogin(response.data, dispatch, history);
    } else {
      dispatch(apiError("Invalid credentials."));
    }
  } catch (error) {
    dispatch(apiError(messageFromError(error, "Login failed!")));
  }
};

// Round 21: Sign in with Google — `credential` is Google's ID token from the button.
export const googleLoginUser = (credential, rememberMe, history) => async (dispatch) => {
  try {
    const response = await api.post("Auth/google", { credential, rememberMe: !!rememberMe });
    if (response.status === 200) {
      completeLogin(response.data, dispatch, history);
    } else {
      dispatch(apiError("Google sign-in failed."));
    }
  } catch (error) {
    dispatch(apiError(messageFromError(error, "Google sign-in failed.")));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    // Round 8: tell the server (audit trail) before discarding the tokens. Best
    // effort — a failed call must never block the local sign-out.
    try {
      const raw = sessionStorage.getItem("authUser");
      if (raw && JSON.parse(raw)?.token) await api.post("Auth/logout", {});
    } catch (e) { /* ignore */ }
    // Cross-tab logout: clear the localStorage mirror FIRST so other tabs see
    // the storage event and drop their session too (see sessionPersist.js).
    try {
      localStorage.removeItem("persist:authUser");
      localStorage.removeItem("persist:permissions");
    } catch (e) { /* ignore */ }
    sessionStorage.removeItem("authUser");
    sessionStorage.clear();
    let fireBaseBackend = getFirebaseBackend();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
    //   response = postSocialLogin(data);
    // }

    const socialdata = await response;
    if (socialdata) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      history('/dashboard')
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};